import { types } from '../types'

const initialState = {
    WaitingLogin: false,
    SuccessLogin: false,
    ErrorLogin: '',

    WaitingRegister: false,
    SuccessRegister: false,
    ErrorRegister: '',
    User: {},

    WaitingCareer: false,
    SuccessCareer: false,
    ErrorCareer: '',
    Career: [],


    WaitingExistEmail: false,
    SuccessExistEmail: false,
    ErrorExistEmail: '',
    EmailExist: false,

    WaitingCaptcha: false,
    SuccessCaptcha: false,
    ErrorCaptcha: '',
    captchaResult: false,

    WaitingResetPasswoed: false,
    SuccessResetPasswoed: false,
    ErrorResetPasswoed: '',
    ResetPasswoedResult: {}
}

const authReducer = (state = initialState, { type, action, error }) => {
    switch (type) {
        case types.LOGIN_USER_REQUEST: {
            return {
                ...state,
                WaitingLogin: true,
                SuccessLogin: false,
                ErrorLogin: ''
            }
        }
        case types.LOGIN_USER_SUCCESS: {
            return {
                ...state,
                WaitingLogin: false,
                SuccessLogin: true,
                ErrorLogin: '',
                User: action.data
            }
        }
        case types.LOGIN_USER_ERROR: {
            return {
                ...state,
                WaitingLogin: false,
                SuccessLogin: false,
                ErrorLogin: error,
            }
        }
        case types.LOGIN_USER_RESET_PROPS: {
            return {
                ...state,
                WaitingLogin: false,
                SuccessLogin: false,
                ErrorLogin: '',
            }
        }
        //********************************************************************************************* */
        case types.REGISTER_USER_REQUEST: {
            return {
                ...state,
                WaitingRegister: true,
                SuccessRegister: false,
                ErrorRegister: '',
                registerResult: null
            }
        }
        case types.REGISTER_USER_SUCCESS: {
            return {
                ...state,
                WaitingRegister: false,
                SuccessRegister: true,
                registerResult: action.data,
                ErrorRegister: '',
            }
        }
        case types.REGISTER_USER_ERROR: {
            return {
                ...state,
                WaitingRegister: false,
                SuccessRegister: false,
                ErrorRegister: 'error',

            }
        }
        case types.REGISTER_USER_RESET_PROPS: {
            return {
                ...state,
                WaitingRegister: false,
                SuccessRegister: false,
                ErrorRegister: '',
            }
        }
        //**************************************************************************************** */
        case types.GET_CAREER_FIELD_REQUEST: {
            return {
                ...state,
                WaitingCareer: true,
                SuccessCareer: false,
                ErrorCareer: ''
            }
        }
        case types.GET_CAREER_FIELD_SUCCESS: {
            return {
                ...state,
                WaitingCareer: false,
                SuccessCareer: true,
                ErrorCareer: '',
                Career: action.data
            }
        }
        case types.GET_CAREER_FIELD_ERROR: {
            return {
                ...state,
                WaitingCareer: false,
                SuccessCareer: false,
                ErrorCareer: 'erroe',
            }
        }
        case types.GET_CAREER_FIELD_RESET_PROPS: {
            return {
                ...state,
                WaitingCareer: false,
                SuccessCareer: false,
                ErrorCareer: '',
            }
        }

        //************************************************************************************* */
        case types.CHECK_EMAIL_EXIST_REQUEST: {
            return {
                ...state,
                WaitingExistEmail: true,
                SuccessExistEmail: false,
                ErrorExistEmail: ''
            }
        }
        case types.CHECK_EMAIL_EXIST_SUCCESS: {
            return {
                ...state,
                WaitingExistEmail: false,
                SuccessExistEmail: true,
                ErrorExistEmail: '',
                EmailExist: action.data
            }
        }
        case types.CHECK_EMAIL_EXIST_ERROR: {
            return {
                ...state,
                WaitingExistEmail: false,
                SuccessExistEmail: false,
                ErrorExistEmail: 'erroe',
            }
        }
        case types.CHECK_EMAIL_EXIST_RESET_PROPS: {
            return {
                ...state,
                WaitingExistEmail: false,
                SuccessExistEmail: false,
                ErrorExistEmail: '',
            }
        }
        //************************************************************************************* */
        case types.CAPTCHA_VERIFIED_REQUEST: {
            return {
                ...state,
                WaitingCaptcha: true,
                SuccessCaptcha: false,
                ErrorCaptcha: ''
            }
        }
        case types.CAPTCHA_VERIFIED_SUCCESS: {
            return {
                ...state,
                WaitingCaptcha: false,
                SuccessCaptcha: true,
                ErrorCaptcha: '',
                captchaResult: action.data
            }
        }
        case types.CAPTCHA_VERIFIED_ERROR: {
            return {
                ...state,
                WaitingCaptcha: false,
                SuccessCaptcha: false,
                ErrorCaptcha: 'erroe',
            }
        }
        case types.CAPTCHA_VERIFIED_RESET_PROPS: {
            return {
                ...state,
                WaitingCaptcha: false,
                SuccessCaptcha: false,
                ErrorCaptcha: '',
            }
        }
        //************************************************************************************* */
        case types.SEND_RESET_PASSWORD_EMAIL_REQUEST: {
            return {
                ...state,
                WaitingResetPasswoed: true,
                SuccessResetPasswoed: false,
                ErrorResetPasswoed: ''
            }
        }
        case types.SEND_RESET_PASSWORD_EMAIL_SUCCESS: {
            return {
                ...state,
                WaitingResetPasswoed: false,
                SuccessResetPasswoed: true,
                ErrorResetPasswoed: '',
                ResetPasswoedResult: action.data
            }
        }
        case types.SEND_RESET_PASSWORD_EMAIL_ERROR: {
            return {
                ...state,
                WaitingResetPasswoed: false,
                SuccessResetPasswoed: false,
                ErrorResetPasswoed: 'error',
            }
        }
        case types.RESET_IS_EXIST_EMAIL_PROPS: {
            return {
                ...state,
                WaitingExistEmail: false,
                SuccessExistEmail: false,
                EmailExist: false,
            }
        }
        case types.SEND_RESET_PASSWORD_EMAIL_RESET_PROPS: {
            return {
                ...state,
                WaitingResetPasswoed: false,
                SuccessResetPasswoed: false,
                ErrorResetPasswoed: '',
            }
        }
        //************************************************************************************* */




        default:
            return state
    }
}

export default authReducer
